export const PARAMENTOR_RESET = "PARAMENTOR::RESET";
export const PARAMENTOR_BUSY = "PARAMENTOR_BUSY";

export const PARAMENTOR_BANDMATERIALIEN_LIST = "PARAMENTOR::BANDMATERIALIEN::LIST";
export const PARAMENTOR_BANDBESCHICHTUNGEN_LIST = "PARAMENTOR::BANDBESCHICHTUNGEN::LIST";
export const PARAMENTOR_SESSIONS = "PARAMENTOR::PARAMENTOR_SESSIONS::LIST";
export const PARAMENTOR_SESSION_ADDED = "PARAMENTOR::PARAMENTOR_SESSIONS::ADD";
export const PARAMENTOR_SESSION_DELETED = "PARAMENTOR::PARAMENTOR_SESSIONS::DELETE";
export const PARAMENTOR_FORMEN_LIST = "PARAMENTOR::FORMEN::LIST";
export const PARAMENTOR_TRAEGER_TYPEN_LIST = "PARAMENTOR_TRAEGER_TYPEN_LIST";
export const PARAMENTOR_TRAEGER_ABMESSUNGEN_LIST = "PARAMENTOR_TRAEGER_ABMESSUNGEN_LIST";
export const PARAMENTOR_VERGUETUNGSARTEN_LIST = "PARAMENTOR::VERGUETUNGSARTEN::LIST";
export const PARAMENTOR_GEFUEGEARTEN_LIST = "PARAMENTOR::GEFUEGEARTEN::LIST";
export const PARAMENTOR_KUEHLUNGSARTEN_LIST = "PARAMENTOR::KUEHLUNGSARTEN::LIST";
export const PARAMENTOR_LEISTUNGSVORGABEN_LIST = "PARAMENTOR::LEISTUNGSVORGABEN::LIST";
export const PARAMENTOR_PRODUKTE_LIST = "PARAMENTOR::PRODUKTE::LIST";
export const PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNGEN_LIST = "PARAMENTOR::VORHANDENES::SAEGEBAND::AUSFUEHRUNGEN::LIST";

export const PARAMENTOR_MASCHINENHERSTELLER = "PARAMENTOR::MASCHINENHERSTELLER";
export const PARAMENTOR_MASCHINE = "PARAMENTOR::MASCHINE";
export const PARAMENTOR_SAEGEBANDABMESSUNG = "PARAMENTOR::SAEGEBANDABMESSUNG";
export const PARAMENTOR_BANDMATERIALTYP = "PARAMENTOR::BANDMATERIALTYP";
export const PARAMENTOR_BANDBESCHICHTUNG = "PARAMENTOR::BANDBESCHICHTUNG";
export const PARAMENTOR_ERZEUGNIS = "PARAMENTOR::ERZEUGNIS";
export const PARAMENTOR_ERZEUGNIS_WERKSTUECK_FORM = "PARAMENTOR::ERZEUGNIS::WERKSTUECK::FORM";
export const PARAMENTOR_ERZEUGNIS_WERKSTUECK_DURCHMESSER = "PARAMENTOR::ERZEUGNIS::WERKSTUECK::DURCHMESSER";
export const PARAMENTOR_ERZEUGNIS_WERKSTUECK_HOEHE = "PARAMENTOR::ERZEUGNIS::WERKSTUECK::HOEHE";
export const PARAMENTOR_ERZEUGNIS_WERKSTUECK_WANDSTAERKE = "PARAMENTOR::ERZEUGNIS::WERKSTUECK::WANDSTAERKE";
export const PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_TYP = "PARAMENTOR::ERZEUGNIS::WERKSTUECK::TRAEGER::TYP";
export const PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_ABMESSUNG = "PARAMENTOR::ERZEUGNIS::WERKSTUECK::TRAEGER::ABMESSUNG";
export const PARAMENTOR_ERZEUGNIS_WERKSTOFF = "PARAMENTOR::ERZEUGNIS::WERKSTOFF";
export const PARAMENTOR_ERZEUGNIS_WERKSTOFFGRUPPE = "PARAMENTOR::ERZEUGNIS::WERKSTOFFGRUPPE";
export const PARAMENTOR_VERGUETUNGSART = "PARAMENTOR::VERGUETUNGSART";
export const PARAMENTOR_GEFUEGEART = "PARAMENTOR::GEFUEGEART";
export const PARAMENTOR_KUEHLUNGSART = "PARAMENTOR::KUEHLUNGSART";
export const PARAMENTOR_LEISTUNGSVORGABE = "PARAMENTOR::LEISTUNGSVORGABE";
export const PARAMENTOR_LAGENSCHNITT = "PARAMENTOR::LAGENSCHNITT";
export const PARAMENTOR_ANZAHLLAGEN = "PARAMENTOR::ANZAHLLAGEN";
export const PARAMENTOR_ANZAHLPROLAGE = "PARAMENTOR::ANZAHLPROLAGE";
export const PARAMENTOR_VORHANDENES_SAEGEBAND = "PARAMENTOR::VORHANDENES::SAEGEBAND";
export const PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNG = "PARAMENTOR::VORHANDENES::SAEGEBAND::AUSFUEHRUNG";

export const PARAMENTOR_ERROR_SPANNBEREICH = "PARAMENTOR_ERROR_SPANNBEREICH";

export const PARAMENTOR_PRODUKTEMPFEHLUNG = "PARAMENTOR::PRODUKTEMPFEHLUNG";
export const PARAMENTOR_PARAMETEREMPFEHLUNG = "PARAMENTOR::PARAMETEREMPFEHLUNG";
export const PARAMENTOR_PRODUKTEMPFEHLUNG_FAVORITES_LIST = "PARAMENTOR::PRODUKTEMPFEHLUNG_FAVORITES_LIST";

export const PARAMENTOR_KOSTEN_MASCHINENKOSTEN = "PARAMENTOR_KOSTEN_MASCHINENKOSTEN";
export const PARAMENTOR_KOSTEN_KOSTENPROBEDIENER = "PARAMENTOR_KOSTEN_KOSTENPROBEDIENER";
export const PARAMENTOR_KOSTEN_PREISPROBAND = "PARAMENTOR_KOSTEN_PREISPROBAND";
export const PARAMENTOR_KOSTEN_STANDFLAECHE = "PARAMENTOR_KOSTEN_STANDFLAECHE";
export const PARAMENTOR_KOSTEN_STANDFLAECHE_TYP = "PARAMENTOR_KOSTEN_STANDFLAECHE_TYP";
export const PARAMENTOR_KOSTEN_MASCHINENPROBEDIENER = "PARAMENTOR_KOSTEN_MASCHINENPROBEDIENER";
export const PARAMENTOR_KOSTEN_KOSTENERSPARNIS = "PARAMENTOR_KOSTENERSPARNIS";

import { BezeichnungItem, Maschinenhersteller, Maschine, Saegebandabmessung, Erzeugnis, Produktempfehlung, Parameterempfehlung, SaegebandProdukt, Saegeband, Kostenersparnis, ProduktEmpfehlungFavorit, WerkstoffItem, Session } from './types';

interface ParamentorReset {
    type: typeof PARAMENTOR_RESET;
}

interface ParamentorBusy {
    type: typeof PARAMENTOR_BUSY;
    busy: boolean;
}

interface ParamentorBandmaterialienList {
    type: typeof PARAMENTOR_BANDMATERIALIEN_LIST;
    bandmaterialienList: Array<BezeichnungItem>;
}

interface ParamentorBandbeschichtungenList {
    type: typeof PARAMENTOR_BANDBESCHICHTUNGEN_LIST;
    bandbeschichtungenList: Array<BezeichnungItem>;
}

interface ParamentorSessions {
    type: typeof PARAMENTOR_SESSIONS;
    sessions: Array<Session>;
}

interface ParamentorSessionAdded {
    type: typeof PARAMENTOR_SESSION_ADDED;
    session: Session
}

interface ParamentorSessionDeleted {
    type: typeof PARAMENTOR_SESSION_DELETED;
    session: Session
}

interface ParamentorFormenList {
    type: typeof PARAMENTOR_FORMEN_LIST;
    formentList: Array<BezeichnungItem>;
}

interface ParamentorTraegerTypenList {
    type: typeof PARAMENTOR_TRAEGER_TYPEN_LIST;
    traegerTypenList: Array<BezeichnungItem>;
}

interface ParamentorTraegerAbmessungenList {
    type: typeof PARAMENTOR_TRAEGER_ABMESSUNGEN_LIST;
    traegerAbmesungenList: Array<BezeichnungItem>;
}

interface ParamentorVerguetungsartList {
    type: typeof PARAMENTOR_VERGUETUNGSARTEN_LIST;
    verguetungsartList: Array<BezeichnungItem>;
}

interface ParamentorGefuegeartenList {
    type: typeof PARAMENTOR_GEFUEGEARTEN_LIST;
    gefuegeartenList: Array<BezeichnungItem>;
}

interface ParamentorKuehlungsartenList {
    type: typeof PARAMENTOR_KUEHLUNGSARTEN_LIST;
    kuehlungsartenList: Array<BezeichnungItem>;
}

interface ParamentorLeistungsvorgabenList {
    type: typeof PARAMENTOR_LEISTUNGSVORGABEN_LIST;
    leistungsvorgabenList: Array<BezeichnungItem>;
}

interface ParamentorProdukteList {
    type: typeof PARAMENTOR_PRODUKTE_LIST;
    produkteList: Array<BezeichnungItem>;
}

interface ParamentorProdukteAusfuehrungenList {
    type: typeof PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNGEN_LIST;
    vorhandenesSaegebandAusfuehrungenList: Array<Saegeband>;
}

interface ParamentorSpannbereichError {
    type: typeof PARAMENTOR_ERROR_SPANNBEREICH;
    spannbereichError: boolean;
}

interface ParamentorMaschinenhersteller {
    type: typeof PARAMENTOR_MASCHINENHERSTELLER;
    maschinenhersteller?: Maschinenhersteller;
}

interface ParamentorMaschine {
    type: typeof PARAMENTOR_MASCHINE;
    maschine?: Maschine;
}

interface ParamentorSaegebandabmessung {
    type: typeof PARAMENTOR_SAEGEBANDABMESSUNG;
    saegebandabmessung?: Saegebandabmessung;
}

interface ParamentorBandmaterialtyp {
    type: typeof PARAMENTOR_BANDMATERIALTYP;
    bandmaterialtyp: number;
}

interface ParamentorBandbeschichtung {
    type: typeof PARAMENTOR_BANDBESCHICHTUNG;
    bandbeschichtung: number;
}

interface ParamentorErzeugnis {
    type: typeof PARAMENTOR_ERZEUGNIS;
    erzeugnis: Erzeugnis;
}

interface ParamentorErzeugnisWerkstueckForm {
    type: typeof PARAMENTOR_ERZEUGNIS_WERKSTUECK_FORM;
    form: number;
}

interface ParamentorErzeugnisWerkstueckDurchmesser {
    type: typeof PARAMENTOR_ERZEUGNIS_WERKSTUECK_DURCHMESSER;
    durchmesser?: number;
}

interface ParamentorErzeugnisWerkstueckHoehe {
    type: typeof PARAMENTOR_ERZEUGNIS_WERKSTUECK_HOEHE;
    hoehe?: number;
}

interface ParamentorErzeugnisWerkstueckWandstaerke {
    type: typeof PARAMENTOR_ERZEUGNIS_WERKSTUECK_WANDSTAERKE;
    wandstaerke?: number;
}

interface ParamentorErzeugnisWerkstueckTraegerTyp {
    type: typeof PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_TYP;
    traegerTyp?: number;
}

interface ParamentorErzeugnisWerkstueckTraegerAbmessung {
    type: typeof PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_ABMESSUNG;
    traegerAbmessung?: number;
}

interface ParamentorErzeugnisWerkstoff {
    type: typeof PARAMENTOR_ERZEUGNIS_WERKSTOFF;
    werkstoff?: WerkstoffItem;
}

interface ParamentorErzeugnisWerkstoffgruppe {
    type: typeof PARAMENTOR_ERZEUGNIS_WERKSTOFFGRUPPE;
    werkstoffgruppe?: number;
}

interface ParamentorVerguetungsart {
    type: typeof PARAMENTOR_VERGUETUNGSART;
    verguetungsart: number;
}

interface ParamentorGefuegeart {
    type: typeof PARAMENTOR_GEFUEGEART;
    gefuegeart: number;
}

interface ParamentorKuehlungsart {
    type: typeof PARAMENTOR_KUEHLUNGSART;
    kuehlungsart: number;
}

interface ParamentorLeistungsvorgabe {
    type: typeof PARAMENTOR_LEISTUNGSVORGABE;
    leistungsvorgabe: number;
}

interface ParamentorLagenschnitt {
    type: typeof PARAMENTOR_LAGENSCHNITT;
    lagenschnitt: boolean;
}

interface ParamentorAnzahlLagen {
    type: typeof PARAMENTOR_ANZAHLLAGEN;
    anzahlLagen: number;
}

interface ParamentorAnzahlProLage {
    type: typeof PARAMENTOR_ANZAHLPROLAGE;
    anzahlProLage: number;
}

interface ParamentorVorhandenesSaegeband {
    type: typeof PARAMENTOR_VORHANDENES_SAEGEBAND;
    produkt?: SaegebandProdukt;
}

interface ParamentorVorhandenesSaegebandAusfuehrung {
    type: typeof PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNG;
    saegeband?: Saegeband;
}

interface ParamentorProduktempfehlung {
    type: typeof PARAMENTOR_PRODUKTEMPFEHLUNG;
    level: number;
    produktempfehlung?: Produktempfehlung;
}

interface ParamentorProduktempfehlungFavoritesList {
    type: typeof PARAMENTOR_PRODUKTEMPFEHLUNG_FAVORITES_LIST;
    favorites: ProduktEmpfehlungFavorit[]
}

interface ParamentorParameterempfehlung {
    type: typeof PARAMENTOR_PARAMETEREMPFEHLUNG;
    level: number;
    parameterempfehlung?: Parameterempfehlung;
}

interface ParamentorMaschinenkosten {
    type: typeof PARAMENTOR_KOSTEN_MASCHINENKOSTEN;
    maschinenkosten?: number;
}

interface ParamentorKostenProBediener {
    type: typeof PARAMENTOR_KOSTEN_KOSTENPROBEDIENER;
    kostenProBediener?: number;
}

interface ParamentorPreisProBand {
    type: typeof PARAMENTOR_KOSTEN_PREISPROBAND;
    level: number;
    preisProBand?: number;
}

interface ParamentorStandflaeche {
    type: typeof PARAMENTOR_KOSTEN_STANDFLAECHE;
    level: number;
    standflaeche?: number;
}

interface ParamentorStandflaecheTyp {
    type: typeof PARAMENTOR_KOSTEN_STANDFLAECHE_TYP;
    level: number;
    standflaecheTyp: number;
}

interface ParamentorMaschinenProBediender {
    type: typeof PARAMENTOR_KOSTEN_MASCHINENPROBEDIENER;
    level: number;
    maschinenProBediener: number;
}

interface ParamentorKostenersparnis {
    type: typeof PARAMENTOR_KOSTEN_KOSTENERSPARNIS;
    level: number;
    kostenersparnis?: Kostenersparnis;
}

export type ParamentorActionTypes =
    ParamentorReset
    | ParamentorBusy

    | ParamentorBandmaterialienList
    | ParamentorBandbeschichtungenList
    | ParamentorFormenList
    | ParamentorTraegerTypenList
    | ParamentorTraegerAbmessungenList
    | ParamentorVerguetungsartList
    | ParamentorGefuegeartenList
    | ParamentorKuehlungsartenList
    | ParamentorLeistungsvorgabenList
    | ParamentorProdukteList
    | ParamentorProdukteAusfuehrungenList

    | ParamentorSpannbereichError

    | ParamentorMaschinenhersteller
    | ParamentorMaschine
    | ParamentorSaegebandabmessung
    | ParamentorBandmaterialtyp
    | ParamentorBandbeschichtung
    | ParamentorErzeugnis
    | ParamentorErzeugnisWerkstueckForm
    | ParamentorErzeugnisWerkstueckDurchmesser
    | ParamentorErzeugnisWerkstueckHoehe
    | ParamentorErzeugnisWerkstueckWandstaerke
    | ParamentorErzeugnisWerkstueckTraegerTyp
    | ParamentorErzeugnisWerkstueckTraegerAbmessung
    | ParamentorErzeugnisWerkstoff
    | ParamentorErzeugnisWerkstoffgruppe
    | ParamentorVerguetungsart
    | ParamentorGefuegeart
    | ParamentorKuehlungsart
    | ParamentorLeistungsvorgabe
    | ParamentorLagenschnitt
    | ParamentorAnzahlLagen
    | ParamentorAnzahlProLage
    | ParamentorVorhandenesSaegeband
    | ParamentorVorhandenesSaegebandAusfuehrung

    | ParamentorProduktempfehlung
    | ParamentorParameterempfehlung
    | ParamentorProduktempfehlungFavoritesList 

    | ParamentorMaschinenkosten
    | ParamentorKostenProBediener
    | ParamentorPreisProBand
    | ParamentorStandflaeche
    | ParamentorStandflaecheTyp
    | ParamentorMaschinenProBediender
    | ParamentorKostenersparnis
    | ParamentorSessions
    | ParamentorSessionDeleted
    | ParamentorSessionAdded;
